<template>
	<div class="list-container column">
		<div class="title">{{ $t('checklist_view.title') }}</div>
		<div class="panel-list-header">
			<div class="panel-header-item">{{ $t('checklist_view.name') }}</div>
			<div class="panel-header-item">{{ $t('checklist_view.customer') }}</div>
			<div class="panel-filler" />
			<div class="panel-filler" />
		</div>
		<div
			class="panel-list"
			v-for="questionList in questionLists"
			:key="questionList.id"
			@click.stop="onEdit(questionList)"
		>
			<p class="panel-list-item">{{ questionList.name }}</p>
			<p class="panel-list-item">
				{{ questionList.customer ? questionList.customer.name : "-" }}
			</p>
			<div 
				class="list-button" 
				@click.stop="onEdit(questionList)"
				v-if="userIsAllowedToModify(questionList)"
			>
				<i class="fas fa-edit"></i>
			</div>
			<div
				class="list-button"
				v-if="userIsAllowedToModify(questionList)"
				@click.stop="onDelete(questionList)"
			>
				<i class="fas fa-trash-alt"></i>
			</div>
		</div>
		<div class="panel-list no-hover" v-if="questionLists.length == 0">
			<p class="header-item">{{ $t('checklist_view.no_results') }}</p>
		</div>
		<Pagination
			v-if="questionLists.length > 0"
			:pagination="pagination"
			@paginate="paginate"
			@updatePageSize="updatePageSize"
		/>
	</div>
</template>

<script>
import Pagination from '@/components/Pagination';
import { mapGetters, mapActions } from 'vuex';

export default {
	components: {
		Pagination
	},
	props: {
		questionLists: Array
	},
	computed: {
		...mapGetters('questionListStore', ['pagination']),
		...mapGetters('appStore', ['isMobile']),
		...mapGetters('user', ['getUser'])
	},

	methods: {
		...mapActions('questionListStore', ['setCurrentPage', 'setPageSize']),

		userIsAllowedToModify(questionList) {
			if (
				questionList.companyId === null &&
				questionList.customerId === null &&
				this.$isAllowedTo('checklists_edit_global_list') === false
			) {
				return false;
			}

			return true;
		},

		onDelete(questionList) {
			this.$emit('delete', questionList);
		},

		onEdit(questionList) {
			if (!this.$isAllowedTo('checklists_edit_global_list') && questionList.company === null) return;

			this.$emit('edit', questionList);
		},

		paginate(page) {
			this.setCurrentPage(page);
			this.$emit('search');
		},

		updatePageSize(size) {
			this.setPageSize(size);
			this.setCurrentPage(1);
			this.$emit('search');
		}
	}
};
</script>
